import { lazy } from 'react';

const CreateRoleModal = lazy(
  () => import('modules/StaffAccountManagement/modals/CreateRoleModal'),
);

const CreateStaffUserModal = lazy(
  () => import('modules/StaffAccountManagement/modals/CreateStaffUserModal'),
);

const DeactivateRoleModal = lazy(
  () => import('modules/StaffAccountManagement/modals/DeactivateRoleModal'),
);

const DeactivateUserModal = lazy(
  () => import('modules/StaffAccountManagement/modals/DeactivateUserModal'),
);

const MapTitlesModal = lazy(
  () => import('modules/StaffAccountManagement/modals/MapTitlesModal'),
);

const ReassignRoleModal = lazy(
  () => import('modules/StaffAccountManagement/modals/ReassignRoleModal'),
);

const ReassignAccessModal = lazy(
  () => import('modules/StaffAccountManagement/modals/ReassignAccessModal'),
);

const DeleteStaffUser = lazy(
  () => import('modules/StaffAccountManagement/modals/DeleteStaffUser'),
);

export default {
  CREATE_ROLE_MODAL: CreateRoleModal,
  CREATE_STAFF_USER_MODAL: CreateStaffUserModal,
  DEACTIVATE_ROLE_MODAL: DeactivateRoleModal,
  DEACTIVATE_USER_MODAL: DeactivateUserModal,
  REASSIGN_ROLE_MODAL: ReassignRoleModal,
  REASSIGN_ACCESS_MODAL: ReassignAccessModal,
  DELETE_STAFF_USER: DeleteStaffUser,
  MAP_TITLES_MODAL: MapTitlesModal,
};
